import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'objtype',
})
export class ObjTypePipe implements PipeTransform {
  transform(value: number, mode?: 'point' | 'line'): 'point' | 'line' | boolean {
    return mode ? ObjTypePipe.is(value, mode) : ObjTypePipe.is(value);
  }

  static is(value: number): 'point' | 'line';
  static is(value: number, mode: 'point' | 'line'): boolean;
  static is(value: number, mode?: 'point' | 'line') {
    let typ: 'point' | 'line';
    switch (value) {
      case 1:
      case 3:
        typ = 'point';
        break;
      case 2:
      case 4:
        typ = 'line';
        break;
    }
    return mode ? typ == mode : typ;
  }

  static isLine = (value: number): boolean => ObjTypePipe.is(value, 'line');
  static isPoint = (value: number): boolean => ObjTypePipe.is(value, 'point');
}
